var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5001C3 14.6357 6.36455 18.0002 10.5001 18.0002C14.6357 18.0002 18.0002 14.6357 18.0002 10.5001C18.0002 6.36455 14.6357 3 10.5001 3C6.36455 3 3 6.36455 3 10.5001Z",
    fill: "#1752AF",
    stroke: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4999 15.1258C10.169 15.1258 9.8999 14.8567 9.8999 14.5258C9.8999 14.1949 10.169 13.9258 10.4999 13.9258C10.8308 13.9258 11.0999 14.1949 11.0999 14.5258C11.0999 14.8567 10.8308 15.1258 10.4999 15.1258Z",
    fill: "#1752AF",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2002 11.7247V7.52461C10.2002 7.35901 10.3343 7.22461 10.5002 7.22461C10.6661 7.22461 10.8002 7.35901 10.8002 7.52461V11.7247C10.8002 11.8903 10.6661 12.0247 10.5002 12.0247C10.3343 12.0247 10.2002 11.8903 10.2002 11.7247Z",
    fill: "#1752AF",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAlert);
export default __webpack_public_path__ + "static/media/BlueAlert.7b155df0ad9ce7fc15fd238a2c60ab58.svg";
export { ForwardRef as ReactComponent };